import type { ExtractPropTypes } from 'vue'
import { ref, computed, toRefs, watch, onMounted } from 'vue'
import { useField, useFieldError } from 'vee-validate'

export default (props: ExtractPropTypes<any>) => {
  const { prop, name } = toRefs(props)

  const field = ref<any>(null)
  const errorMessage = ref<null | ComputedRef>(null)
  const cProp = computed(() => prop?.value)
  const setFields = (prop: any) => {
    if (typeof prop === 'string' && prop !== '') {
      field.value = useField(prop, undefined, {
        label: name?.value || prop,
        validateOnValueUpdate: true,
        validateOnMount: false
      })
      errorMessage.value = useFieldError(cProp.value)
    }
  }
  watch(
    () => cProp.value,
    (val: any) => {
      setFields(val)
    }
  )
  onMounted(() => {
    setFields(cProp.value)
  })

  return {
    field,
    errorMessage
  } as {
    field: any
    errorMessage: null | ComputedRef
  }
}
